export * from './patients.byphone.added.actions'
export * from './patients.byphone.main.actions'
export * from './patients.byphone.order.actions'
export const patientsByphoneRequest = () => ({ type: 'PATIENTS_BYPHONE_REQUEST' } as const)